var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_5097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8075 8.60875C3.845 8.24 3.70375 7.87625 3.42875 7.62875L0.62875 4.25375V3.75H9.32625L16.0487 18.4938L21.9588 3.75H30.25V4.25375L27.855 6.55C27.6487 6.7075 27.5463 6.96625 27.5888 7.2225V24.095C27.5463 24.35 27.6487 24.6087 27.855 24.7662L30.1937 27.0625V27.5662H18.4288V27.0625L20.8525 24.71C21.09 24.4725 21.09 24.4025 21.09 24.0388V10.4013L14.3537 27.5113H13.4438L5.6 10.4013V21.8688C5.535 22.35 5.695 22.8363 6.03375 23.1838L9.185 27.0062V27.5113H0.25V27.0062L3.40125 23.1838C3.73875 22.835 3.88875 22.3463 3.8075 21.8688V8.60875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_5097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.a7498dd6c589242816fad1498e86bb18.svg";
export { ForwardRef as ReactComponent };